import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ActiveRateCodeModel } from '../../models/reports/active-ratecode.model';
import { ActiveRateCodeService } from '../../service/active-ratecode.service';
import { Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';

@Component({
  selector: 'app-active-rate-code',
  templateUrl: './active-rate-code.component.html',
  styleUrls: ['./active-rate-code.component.css']
})
export class ActiveRateCodeComponent implements OnInit {
  bgColor122: boolean = true;
  bgColor234: boolean = true;
  bgColor456: boolean = true;
  bgColor789: boolean = true;
  bgColor543: boolean = true;
  bgColor326: boolean = true;
  bgColor412: boolean = true;
  bgColor577: boolean = true;
  bgColor622: boolean = true;
  bgColor812: boolean = true;

  bgColor192: boolean = true;
  bgColor746: boolean = true;
  bgColor581: boolean = true;
  bgColor791: boolean = true;
  bgColor960: boolean = true;
  rowcolor: string = 'tablerow';

  activeRateCodeModel = new ActiveRateCodeModel(0, 0, '', '', '', '', [], [], '', '', null, null);

  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public productsData: ActiveRateCodeModel[] = [];
  public salesChannelsData: ActiveRateCodeModel[] = [];
  corps: number[] = [];
  corpsData: ActiveRateCodeModel[] = [];
  changeColor: boolean[] = [];
  mySalesChannelSet = new Set<string>();

  constructor(private router: Router, private activeRateCodeService: ActiveRateCodeService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.getProducts();
    this.getSalesChannels();
    this.getCorps();
  }

  redirect(url: string) {
    this.activeRateCodeService.activeRateCodeModel = this.activeRateCodeModel;
    this.activeRateCodeService.mySalesChannelSet = this.mySalesChannelSet;
    this.router.navigate(['/' + url]);
  }

  public getCorps(): void {
    this.activeRateCodeService.getCorps()
      .subscribe((data: any) => {
        this.corpsData = data;
        for (let corpdata of this.corpsData) {
          this.corps.push(corpdata.corp);
        }
        this.corpsData = data;
        console.log("corpdata = " + this.corpsData);
      });
  }

  public getProducts(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.activeRateCodeService.getProducts().subscribe(
        (response: ActiveRateCodeModel[]) => {
          this.productsData = response;
          this.productsData = this.productsData.sort((a, b) => (a.productName < b.productName) ? -1 : 1);
          this.refreshing = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          this.refreshing = false;
        }
      )
    );
  }

  public getSalesChannels(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.activeRateCodeService.getSalesChannels().subscribe(
        (response: ActiveRateCodeModel[]) => {
          this.salesChannelsData = response;
          this.salesChannelsData = this.salesChannelsData.sort((a, b) => (a.salesChannelFieldValue < b.salesChannelFieldValue) ? -1 : 1);
          this.refreshing = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          this.refreshing = false;
        }
      )
    );
  }

  clickedRow(val: any) {

    var numeric = Number(val.target.innerText);
    this.rowcolor = "tablerowB";
    let condi: boolean = true;
    this.activeRateCodeModel.corps.forEach((value: any, index: any) => {
      if (value === numeric) {
        this.activeRateCodeModel.corps.splice(index, 1);
        condi = false;
      }
    });
    if (condi) {
      this.activeRateCodeModel.corps.push(numeric);
    }
    console.log(' corps====', this.activeRateCodeModel);

  }

  private sendNotification(notificationType: NotificationType, message: string): void {
    if (message) {
      this.notificationService.notify(notificationType, message);
    } else {
      this.notificationService.notify(notificationType, 'An error occurred. Please try again.');
    }
  }











  checkAll() {
    this.rowcolor = 'tablerowr';
    this.bgColor122 = false;
    this.bgColor234 = false;
    this.bgColor456 = false;
    this.bgColor789 = false;
    this.bgColor543 = false;

    this.bgColor326 = false;
    this.bgColor412 = false;
    this.bgColor577 = false;
    this.bgColor622 = false;
    this.bgColor812 = false;

    this.bgColor192 = false;
    this.bgColor746 = false;
    this.bgColor581 = false;
    this.bgColor791 = false;
    this.bgColor960 = false;
  }

  uncheckAll() {
    this.rowcolor = 'tablerow';
    this.bgColor122 = true;
    this.bgColor234 = true;
    this.bgColor456 = true;
    this.bgColor789 = true;
    this.bgColor543 = true;

    this.bgColor326 = true;
    this.bgColor412 = true;
    this.bgColor577 = true;
    this.bgColor622 = true;
    this.bgColor812 = true;

    this.bgColor192 = true;
    this.bgColor746 = true;
    this.bgColor581 = true;
    this.bgColor791 = true;
    this.bgColor960 = true;
  }



}

